// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Status filter chip row (see StatusFilterChips.tsx).
 *
 * Every colour here is a var from styles/global.css - the palette stays in one
 * place. The one thing the stylesheet cannot know is which status a chip
 * stands for, so the component sets \`--chip-color\` per chip from its page's
 * status map and the rules below build the on / off / hover states out of it.
 *
 * Rules are written as \`button.chip\` rather than \`.chip\`: MUI's own generated
 * class is a single class selector, so a bare class here would depend on style
 * injection order to win. The extra element selector settles it. */

.StatusFilterChips_row__Uoewt {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

button.StatusFilterChips_chip__Hh808 {
  /* Overridden inline per chip; the fallback keeps an unstyled chip grey. */
  --chip-color: var(--chipInactiveText);

  border-radius: var(--statusTokenRadius);
  color: var(--chipInactiveText);
  background: var(--white);
  border: 1px solid var(--chipInactiveBorder);
}

/* Off chips preview their status colour on hover, so it stays obvious what
   turning one on will look like. */
button.StatusFilterChips_chip__Hh808:hover {
  color: var(--white);
  background: var(--chip-color);
  border: 1px solid var(--chip-color);
}

button.StatusFilterChips_chipActive__7RY3W {
  color: var(--white);
  background: var(--chip-color);
  border: 1px solid var(--chip-color);
}

button.StatusFilterChips_chipActive__7RY3W:hover {
  color: var(--chip-color);
  background: var(--white);
}

/* The select-all chip has no status of its own - it carries the neutral grey
   in both directions. */
button.StatusFilterChips_chipAll__e-tYa {
  --chip-color: var(--chipAllToggle);
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/StatusFilterChips.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;mEASmE;;AAEnE;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,0EAA0E;EAC1E,qCAAqC;;EAErC,uCAAuC;EACvC,8BAA8B;EAC9B,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;mCACmC;AACnC;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;wBACwB;AACxB;EACE,kCAAkC;AACpC","sourcesContent":["/* Status filter chip row (see StatusFilterChips.tsx).\n *\n * Every colour here is a var from styles/global.css - the palette stays in one\n * place. The one thing the stylesheet cannot know is which status a chip\n * stands for, so the component sets `--chip-color` per chip from its page's\n * status map and the rules below build the on / off / hover states out of it.\n *\n * Rules are written as `button.chip` rather than `.chip`: MUI's own generated\n * class is a single class selector, so a bare class here would depend on style\n * injection order to win. The extra element selector settles it. */\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\nbutton.chip {\n  /* Overridden inline per chip; the fallback keeps an unstyled chip grey. */\n  --chip-color: var(--chipInactiveText);\n\n  border-radius: var(--statusTokenRadius);\n  color: var(--chipInactiveText);\n  background: var(--white);\n  border: 1px solid var(--chipInactiveBorder);\n}\n\n/* Off chips preview their status colour on hover, so it stays obvious what\n   turning one on will look like. */\nbutton.chip:hover {\n  color: var(--white);\n  background: var(--chip-color);\n  border: 1px solid var(--chip-color);\n}\n\nbutton.chipActive {\n  color: var(--white);\n  background: var(--chip-color);\n  border: 1px solid var(--chip-color);\n}\n\nbutton.chipActive:hover {\n  color: var(--chip-color);\n  background: var(--white);\n}\n\n/* The select-all chip has no status of its own - it carries the neutral grey\n   in both directions. */\nbutton.chipAll {\n  --chip-color: var(--chipAllToggle);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `StatusFilterChips_row__Uoewt`,
	"chip": `StatusFilterChips_chip__Hh808`,
	"chipActive": `StatusFilterChips_chipActive__7RY3W`,
	"chipAll": `StatusFilterChips_chipAll__e-tYa`
};
export default ___CSS_LOADER_EXPORT___;
